import { uniqueId } from "lodash";
import { groupBy } from "../../utils/Array"
import { useCallback, useState } from "react"
import moment from "moment";
import extratoNovaService from "../../services/extratoNovaService";

const TabelaConciliados = ({ lancamentos, acc, onUpdateLancamentos, esteiraID }: { lancamentos: any[], acc: string, onUpdateLancamentos: Function, esteiraID: number }) => {

    const [loadingRemove, setLoadingRemove] = useState(false);

    const classificarDescricao = useCallback((codigo, tipo, tipoLancamentoExtrato, regra) => {
        if (!tipoLancamentoExtrato)
            return "";

        if (codigo === acc) {
            return regra && regra.includes("Extrato") ? "Extrato importado" : regra;
        } else {
            if (tipoLancamentoExtrato === tipo) {
                return "Provisão encontrada";
            }

            return "Lançamento gerado";
        }

    }, [acc])

    const onRemove = useCallback(async (key: any) => {
        if (!loadingRemove) {
            setLoadingRemove(true)
            await extratoNovaService.removerVinculoExtrato(esteiraID, key)
            onUpdateLancamentos((old: any) => {
                return old.filter((a: any) => a.chaveVinculo !== key)
            })
            setLoadingRemove(false)
        }
    }, [esteiraID, loadingRemove])

    return (
        <div className='row'>
            <div className="col-md-12">
                <h2>Lançamentos Conciliados</h2>
            </div>
            <div className='col-md-12'>
                {lancamentos && Object.keys(groupBy(lancamentos, 'chaveVinculo')).map((item: any) => (
                    <div className="row mt-2" style={{ padding: '5px', border: '1px solid grey', borderRadius: '5px', position: 'relative' }} key={uniqueId()}>
                        <div className="col-md-12" style={{ position: 'relative' }}>
                            {loadingRemove ? (
                                <div className="spinner-border text-success" role="status" style={{ textAlign: 'center', position: 'absolute', right: '0' }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                <button style={{ background: 'transparent', border: 'none', textAlign: 'center', position: 'absolute', right: '0' }}>
                                    <i onClick={() => onRemove(item)} className="fas fa-trash" style={{ color: 'red', fontSize: '15px' }}></i>
                                </button>
                            )}

                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Conta</th>
                                        <th scope="col">Data</th>
                                        <th scope="col">Histórico</th>
                                        <th scope="col">Valor</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Descrição</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lancamentos.filter(f => f.chaveVinculo === item).map((item2) => (
                                        <tr>
                                            <th scope="row">{item2.codigoContabil} - {item2.descricaoCodigoContabil}</th>
                                            <th>{moment(item2.dataLancamento).format('DD/MM/YYYY')}</th>
                                            <th>{item2.historico}</th>
                                            <th>{item2.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</th>
                                            <th>{item2.tipoLancamento}</th>
                                            <th>{classificarDescricao(item2.codigoContabil, item2.tipoLancamento, lancamentos.find(f => f.chaveVinculo === item && f.codigoContabil === acc)?.tipoLancamento, item2.tipoRegra)}</th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TabelaConciliados